import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { ApiResponse, IdNamePair, PincodeInfoDisplay } from "@/types/global";

export default class CommonApi extends ApiVerified {
  async getCities(): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<IdNamePair>>(`common/get-all-cities`);
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getStates(): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<IdNamePair>>(`common/get-all-states`);
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  // 404s for a pincode that does not exist — callers treat that as "invalid pincode".
  async getPincodeInfo(pincode: number): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<PincodeInfoDisplay>(`common/pincode-info`, {
        params: { pincode },
      });
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
